import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { NavController } from 'ionic-angular';

/**
   * Logger Factory
   * @namespace title: is the titlte od previous page
   * <ute-toolbar [title]="prevPage"></ute-toolbar>
   * --- PUT INSIDE THE ionViewDidLoad --- 
   * ionViewDidLoad() {
      if(this.navCtrl.getPrevious() !== null){
        this.prevPage = this.navCtrl.getPrevious().id;
      }
    }
*/

@Component({
  selector: 'ute-toolbar',
  templateUrl: 'ute-toolbar.component.html'
})
export class UteToolbarComponent  implements OnChanges {
  @Input() title: any;
  @Input() pageName: any;
  @Input() icon: any;
  @Output() onAction =  new EventEmitter;
  
  public rootPage: any = 'Intro';
  public hasTitle: boolean;

  constructor(public navCtrl: NavController) {}

  onClickIcon(action){
    this.onAction.emit(action);
  }

  ngOnChanges(change: SimpleChanges){
    if(change.title && this.navCtrl.getPrevious() && this.navCtrl.getPrevious().id){
      if(change.title.currentValue === this.navCtrl.getActive().id){
        this.title = 'BACK';
      }
    }
    if(this.navCtrl.getPrevious() === null){
      this.title = 'BACK';
    }
    if(this.navCtrl.getPrevious() && this.navCtrl.getPrevious().id === 'login'){
      this.title = 'Intro';
    }
    if(change && change.pageName && change.pageName.currentValue.length > 0){
      this.hasTitle = true;
    }
  }

  goToPreviousPage(){
    if(this.navCtrl.getPrevious() === null){
      this.navCtrl.push('Intro');
    } else {
      this.navCtrl.pop();
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/molecules/ute-toolbar/ute-toolbar.component.ts